<template>
  <div v-if="item">
    <div v-if="column.key == 'bvn_photo_status' && item.bvn_image">
        <div class="avatar-group">
            <div class="avatar-group-item material-shadow-none" v-b-tooltip.hover
                title="BVN image">
                <div class="avatar rounded-circle bg-light cursor-pointer">
                    <img @click="showProfileImg(item.bvn_image)"
                        :src="item.bvn_image" alt=""
                        class="w-100 h-100 rounded-circle img-fluid" />
                </div>
            </div>
            <div class="avatar-group-item material-shadow-none" v-b-tooltip.hover
                title="Profile image">
                <div :class="item.bvn_photo_status ? 'border-primary' : 'border-danger'"
                    class="border border-3 rounded-circle avatar bg-transparent cursor-pointer">
                    <img @click="showProfileImg(item.profile_image)"
                        :src="absoluteUrl(item.profile_image)" alt=""
                        class="w-100 h-100 rounded-circle img-fluid" />
                </div>
            </div>
        </div>
    </div>
    <div v-else-if="column.key == 'nin_photo_status' && item.nin_image">
        <div class="avatar-group">
            <div class="avatar-group-item material-shadow-none" v-b-tooltip.hover
                title="BVN image">
                <div class="avatar rounded-circle bg-light cursor-pointer">
                    <img @click="showProfileImg(item.nin_image)"
                        :src="item.nin_image" alt=""
                        class="w-100 h-100 rounded-circle img-fluid" />
                </div>
            </div>
            <div class="avatar-group-item material-shadow-none" v-b-tooltip.hover
                title="Profile image">
                <div :class="item.nin_photo_status ? 'border-primary' : 'border-danger'"
                    class="border border-3 rounded-circle avatar bg-transparent cursor-pointer">
                    <img @click="showProfileImg(item.profile_image)"
                        :src="absoluteUrl(item.profile_image)" alt=""
                        class="w-100 h-100 rounded-circle img-fluid" />
                </div>
            </div>
        </div>
    </div>
    <div v-else-if="column.key == 'bvn_first_name_status'" @click="navigateTo(data.item)"
        class="cursor-pointer">
        <div>A/C:
            <strong
                :class="item.bvn_first_name_status ? 'text-success' : 'text-danger'">{{
                item.profile_first_name }}</strong>
        </div>
        <div>BVN: <strong>{{ item.bvn_first_name }}</strong></div>
    </div>
    <div v-else-if="column.key == 'bvn_last_name_status'" @click="navigateTo(data.item)"
        class="cursor-pointer">
        <div>A/C:
            <strong
                :class="item.bvn_last_name_status ? 'text-success' : 'text-danger'">{{
                item.profile_last_name }}</strong>
        </div>
        <div>BVN: <strong>{{ item.bvn_last_name }}</strong></div>
    </div>
    <div v-else-if="column.key == 'nin_first_name_status'" @click="navigateTo(data.item)"
        class="cursor-pointer">
        <div>A/C:
            <strong
                :class="item.nin_first_name_status ? 'text-success' : 'text-danger'">{{
                item.profile_first_name }}</strong>
        </div>
        <div>NIN: <strong>{{ item.nin_first_name }}</strong></div>
    </div>
    <div v-else-if="column.key == 'nin_last_name_status'" @click="navigateTo(data.item)"
        class="cursor-pointer">
        <div>A/C:
            <strong
                :class="item.nin_last_name_status ? 'text-success' : 'text-danger'">{{
                item.profile_last_name }}</strong>
        </div>
        <div>NIN: <strong>{{ item.nin_last_name }}</strong></div>
    </div>
    <div v-else-if="column.key == 'manual_pass_reason'" @click="navigateTo(data.item)"
        class="cursor-pointer">
        {{ item.manual_pass_reason }}
    </div>
    <div v-else-if="column.key == 'bvn_status'" @click="navigateTo(data.item)"
        class="cursor-pointer" v-b-tooltip.hover :title="item.bvn_error">
        <span v-html="statusBadge(item.bvn_status)"></span>
    </div>
    <div v-else-if="column.key == 'nin_status'" @click="navigateTo(data.item)"
        class="cursor-pointer" v-b-tooltip.hover :title="item.nin_error">
        <span v-html="statusBadge(item.nin_status)"></span>
    </div>
    <div v-else-if="column.key == 'bvn_date_of_birth' && item.bvn_date_of_birth" @click="navigateTo(data.item)"
        class="cursor-pointer" :class="{'text-danger': item.bvn_date_of_birth_status != 1 }">
        {{ $filters.date(item.bvn_date_of_birth) }} <br> ({{
            $filters.calculateAge(item.bvn_date_of_birth) }} yrs)
    </div>
    <div v-else-if="column.key == 'nin_date_of_birth' && item.nin_date_of_birth" @click="navigateTo(data.item)"
        class="cursor-pointer" :class="{'text-danger': item.nin_date_of_birth_status != 1 }">
        {{ $filters.date(item.nin_date_of_birth) }} <br> ({{
            $filters.calculateAge(item.nin_date_of_birth) }} yrs)
    </div>
  </div>
</template>

<script>
export default {
    props:{
        item: {
            type: Object,
            default: null
        },
        column:{
            type: Object,
            required: true
        }
    },
}
</script>

<style>

</style>
